import Tabs from './tabs';
import TabNav from './tab-nav';
import TabPanel from './tab-panel';
export { Tabs, TabNav, TabPanel };
